import { AnnexRoom } from "./annex-room.model";
import { Availability } from "./availability.model";
import { RoomBooking } from "./room-booking.model";

export enum BookingTypeEnum {
    ExclusiveBooking = "exclusiveBooking",
    PartialBooking = "partialBooking",
}

export class Booking {
    constructor(public availability: Availability) {
    }

    bookingType: BookingTypeEnum;
    annexRooms: AnnexRoom;
    roomsBooking: RoomBooking[];

    finalPrice: number;
}